import React, { createContext, useCallback, useContext, useState } from 'react';

type Toast = { id: number; message: string; type?: 'info'|'error' };

const ToastContext = createContext<{ show: (m:string, t?:Toast['type']) => void } | null>(null);

export function useToast() { const ctx = useContext(ToastContext); if (!ctx) throw new Error('useToast must be used within ToastProvider'); return ctx; }

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);
  const show = useCallback((message: string, type: Toast['type'] = 'info') => {
    const id = Date.now() + Math.floor(Math.random()*1000);
    const t = { id, message, type };
    setToasts(prev => [...prev, t]);
    setTimeout(() => setToasts(prev => prev.filter(x => x.id !== id)), 4000);
  }, []);

  return (
    <ToastContext.Provider value={{ show }}>
      {children}
      <div aria-live="polite" style={{ position:'fixed', right: 12, bottom: 12, zIndex: 9999 }}>
        {toasts.map(t => (
          <div key={t.id} style={{ marginBottom: 8, padding: '10px 14px', borderRadius: 8, background: t.type === 'error' ? '#fdecea' : '#eef2ff', color: t.type === 'error' ? '#9b1c1c' : '#023e8a', boxShadow: '0 6px 18px rgba(2,6,23,0.08)' }}>{t.message}</div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export default ToastProvider;
